import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { firstValueFrom } from "rxjs";
import DisplaySizeService from "../Common/services/displaySize.service";
import ExceptionService from "../Common/services/exception.service";
import UserService from "../Common/services/user.service";
import { Constants } from "../../constants";

const mobileRoutes: string[] = [
    "/mobile",
    "/settings",
    // Commented since we still need to make dialogs mobile friendly
    // "/datamaintenance",
    // "/datamaintenance/carriers",
    // "/datamaintenance/customers",
    // "/datamaintenance/stoplocations",
    // "/datamaintenance/factor",
];

@Injectable({ providedIn: "root" })
export class MobileGuard {
    constructor(
        private router: Router,
        private displaySizeService: DisplaySizeService,
        private exceptionService: ExceptionService,
        private userService: UserService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const url: string = state.url;
        return this.checkMobile(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(route, state);
    }

    canLoad(route: Route) {
        const url = `/${route.path}`;
        return this.checkMobile(url);
    }

    async checkMobile(url: string): Promise<true | UrlTree> {
        const isCustomer = await firstValueFrom(this.userService.hasRole(Constants.roles.Customer));

        if (isCustomer) {
            if (url === "/mobile") return this.router.parseUrl("/");
            return true;
        }

        //xs < 600  sm < 960    md < 1280   lg < 1920   xl < 5000
        if (this.displaySizeService.usingMobile) {
            // when mobile is activated only allow mobile and settings route
            if (!mobileRoutes.includes(url)) return this.router.parseUrl("/mobile");
            return true;
        } else {
            if (url == "/mobile") return this.router.parseUrl("/");
            return true;
        }
    }
}
